import { useState } from "react";

import { Link } from "react-router-dom";

import AddNewDeviceModal from "./AddNewDeviceModal";
import GlobalSearch from "./GlobalSearch";
import RecoverDfnsKeyModal from "./RecoverDfnsKeyModal";
import NomyxLogo from "../assets/nomyx_logo_black.svg";

const NavBar = ({ onLogout }) => {
  const [isAddDeviceVisible, setIsAddDeviceVisible] = useState(false);
  const [isRecoverVisible, setIsRecoverVisible] = useState(false);

  return (
    <>
      <nav className="bg-white text-black p-6">
        <ul className="flex space-x-6">
          <li style={{ padding: "20px 20px", minWidth: "100px" }}>
            <img src={NomyxLogo} alt="Nomyx Logo" className="h-8 w-auto" />
          </li>
          <li>
            <Link to="/" className="font-medium text-gray-700 transition-colors duration-200 hover:text-[#7F56D9]">
              Home
            </Link>
          </li>
          <li>
            <span>
              <a
                href={process.env.REACT_APP_MINTIFY_UI_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center font-medium text-gray-700 transition-colors duration-200 hover:text-[#7F56D9]"
              >
                Mint
                <span className="text-[#7F56D9]">↗</span>
              </a>
            </span>
          </li>
          <li>
            <Link to="/topics" className="font-medium text-gray-700 transition-colors duration-200 hover:text-[#7F56D9]">
              Compliance Rules
            </Link>
          </li>
          <li>
            <Link to="/issuers" className="font-medium text-gray-700 transition-colors duration-200 hover:text-[#7F56D9]">
              Trusted Issuers
            </Link>
          </li>
          <li>
            <Link to="/identities" className="font-medium text-gray-700 transition-colors duration-200 hover:text-[#7F56D9]">
              Identities
            </Link>
          </li>

          <li style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
            <GlobalSearch />
          </li>

          <li>
            <button
              onClick={() => setIsAddDeviceVisible(true)}
              className="font-medium text-gray-700 transition-colors duration-200 hover:text-[#7F56D9]"
            >
              Add New Device
            </button>
          </li>
          <li>
            <button
              onClick={() => setIsRecoverVisible(true)}
              className="font-medium text-gray-700 transition-colors duration-200 hover:text-[#7F56D9]"
            >
              Recovery Key
            </button>
          </li>

          <li style={{ marginLeft: "auto" }}>
            <button onClick={onLogout} className="bg-black text-white px-4 py-2 rounded-md">
              Logout
            </button>
          </li>
        </ul>
      </nav>

      <AddNewDeviceModal visible={isAddDeviceVisible} onClose={() => setIsAddDeviceVisible(false)} />
      <RecoverDfnsKeyModal visible={isRecoverVisible} onClose={() => setIsRecoverVisible(false)} />
    </>
  );
};

export default NavBar;
